import { GRAY } from '@applyboard/ui-components';
export var API_ROOT = window.API_ROOT || '';
export var mobileBottomBorder = {
  xs: "1px solid ".concat(GRAY[18]),
  md: 'none'
};
export var displayMobileOnly = {
  xs: 'block',
  md: 'none'
};
export var displayDesktopOnly = {
  xs: 'none',
  md: 'block'
};